import "./App.css";
import "react-notifications/lib/notifications.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as theme from "./utils/theme";
import { ThemeProvider } from "styled-components";
import { AuthContextProvider } from "./contexts/auth";
import { ReferenceContextProvider } from "./contexts/reference";
import AuthEntry from "./pages/entry";
import StoreSettings from "pages/Settings/Store";
import ScheduleSettings from "pages/Settings/Schedule";
import PodSettings from "pages/Settings/Pod";
import PosCheckStore from "pages/Settings/PosCheck";
import Login from "pages/__Login";
import Register from "pages/__Register";
import { Amplify } from "aws-amplify";
import configFile from "config.json";
import { NotificationContainer } from "react-notifications";
import Address from "pages/Address/Address";
import Location from "pages/Address/Location";
import SearchLocation from "pages/Address/SearchLocation";
import Menus from "pages/Menus/Menus";
import Combo from "pages/Menus/Combo";
import CopyCombo from "pages/Menus/CopyCombo";
import ImagePage from "pages/Menus/Image";
import Log from "pages/Menus/Log";
import Users from "pages/Users/Users";
import Profile from "pages/Profile";
import Translate from "pages/Menus/Translate";
import Logout from "components/Logout";
import Tags from "pages/Tags";
import React from "react";
import GetmenuAllStore from "pages/Menus/GetmenuAllStore";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SearchUsers from "pages/Users/SearchUsers";
import ProductCopy from "pages/Menus/ProductCopy";
import Products from "pages/Product";
import Modifiers from "pages/Modifiers";
import ComboPage from "pages/Combo";
import EditComboPage from "pages/Combo/EditComboPage";
import CreateComboPage from "pages/Combo/CreateComboPage";
import Images from "pages/Images";
import AuditLogs from "pages/AuditLogs";
import Discount from "pages/Discount";
Amplify.configure(configFile.awsmobile);
export const queryClient = new QueryClient();

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AuthContextProvider>
          <ReferenceContextProvider>
            <QueryClientProvider client={queryClient}>
              <Routes>
                <Route path="/" element={<AuthEntry />}>
                  <Route path="/stores-settings" element={<StoreSettings />} />
                  {/* <Route path="/dashboard" element={<Dashboard />} /> */}
                  <Route
                    path="/schedule-settings"
                    element={<ScheduleSettings />}
                  />
                  <Route path="/pod-settings" element={<PodSettings />} />
                  <Route path="/pos-check" element={<PosCheckStore />} />
                  <Route path="/edit-address" element={<Address />} />
                  <Route path="/edit-location" element={<Location />} />
                  <Route path="/search-location" element={<SearchLocation />} />
                  <Route path="/list" element={<Menus />} />
                  {/* Newly added pages START*/}
                  <Route path="/tags" element={<Tags />} />
                  <Route path="/list-product" element={<Products />} />
                  <Route path="/product-images" element={<Images />} />
                  <Route path="/deals" element={<ComboPage />} />
                  <Route path="/deals/create" element={<CreateComboPage />} />
                  <Route path="/deals/edit/:comboId" element={<EditComboPage />} />
                  <Route path="/modifiers" element={<Modifiers />} />
                  <Route path="/audit-logs" element={<AuditLogs />} />
                  <Route path="/discount" element={<Discount />} />
                  {/* Newly added pages END*/}
                  <Route
                    path="/getmenuAllStore"
                    element={<GetmenuAllStore />}
                  />
                  <Route path="/combo" element={<Combo />} />
                  <Route path="/copyCombo" element={<CopyCombo />} />
                  <Route path="/translate" element={<Translate />} />
                  <Route path="/images" element={<ImagePage />} />
                  {/* <Route path="/product-visibility" element={<ProductVisibility />} /> */}
                  {/* <Route path="/product-settings" element={<ProductSettings />} /> */}
                  <Route path="/product-copy" element={<ProductCopy />} />
                  <Route path="/log" element={<Log />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/search-user" element={<SearchUsers />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/logout" element={<Logout />} />
                </Route>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
              </Routes>
            </QueryClientProvider>
          </ReferenceContextProvider>
        </AuthContextProvider>
      </ThemeProvider>
      <NotificationContainer />
    </Router>
  );
}

export default App;
